<template>
  <div class="caring-title" :style="{ color }">
    <span class="caring-title-icon" :style="iconStyle"></span>
    <slot>
      <span>{{text}}</span>
    </slot>
    <slot name="value"></slot>
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#409eff"
    },
    text: {
      type: String,
      default: ""
    },
    customIconStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    iconStyle() {
      return Object.assign({}, {backgroundColor: this.color}, this.customIconStyle)
    }
  }
}
</script>
<style lang="less">
  .caring-title{
    position: relative;
    margin-bottom: 15px;
    padding-left: 12px;
    font-size: 16px;
    font-weight: 500;
    &-icon{
      position: absolute;
      width: 6px;
      height: 20px;
      top: 50%;
      left: 0;
      border-radius: 8px;
      transform: translateY(-50%);
    }
  }
</style>